import { post, patch } from './commonFetch';

export interface AdminUserProps {
  id?: string;
  userName: string;
  password?: string;
  email: string;
  active: boolean;
  accountId: string;
  customerName: string;
  userId: string;
  created: string;
  roles?: string;
  assignedOrgNodeId?: string;
  selectedRoles?: string[];
}

export interface UpdateAdminUserProps {
  accountId: string,
  editUserId: string,
  active: boolean,
  roles: string,
  assignedOrgNodeId: string,
  selectedRoles?: string[];
  userName: string,
  email: string;
  userId: string;
}

export const createAdminUser = ({
  userName,
  password,
  email,
  active,
  roles,
  accountId,
  customerName,
  userId,
  created,
  assignedOrgNodeId,
  selectedRoles
}: AdminUserProps): Promise<AdminUserProps> => {
  const postBody = {
    userName,
    password,
    email,
    active,
    roles,
    accountId,
    customerName,
    userId,
    created,
    assignedOrgNodeId,
    selectedRoles
  };
  return post('/admin/user/save', postBody);
};

export const updateAdminUser = ({
  accountId,
  editUserId,
  active,
  roles,
  assignedOrgNodeId,
  selectedRoles,
  userName,
  email,
  userId
}: UpdateAdminUserProps): Promise<AdminUserProps> => {
  const postBody = { accountId, editUserId, active, roles, assignedOrgNodeId, selectedRoles, userName, email, userId };
  return patch('/admin/user/save', postBody);
};